// import useUrlParameter from '../utils/useUrlParameter'
import { swalOption } from '../components/swal-opt.js'
import { fetchContent } from '../utils/fetch-data.js'
import { surveyBtnEffect } from '../utils/survey-btn-effect.js'
import submitSurvey from '../utils/submitSurvey.js'
import htmlDecode from '../utils/html-decode.ts'
import useUrlParameter from '../utils/useUrlParameter.ts'
import triggerSyzpModalSlide from '../components/triggerSyzpModalSlide.js'

function triggerSurveyUi() {
	setTimeout(() => {
		const content = document.querySelector('.swal2-content')
		surveyBtnEffect()
		if (content) content.scrollTo(0, 0)
	}, 100)
}

async function trigerPromotionChanel() {
	const confirmButtonText = window.myvars.submit
	// const trigerPC = useUrlParameter(window.location.href, 'pc')
	// if (trigerPC) {
	const { eventId, orderId, collapsePromoChannelDesktop, orderNumber } =
		window.orderSummary

	const html = await fetchContent(
		`/store/order/promotion-chanel?eventId=${eventId}&collapsePromoChannelDesktop=${collapsePromoChannelDesktop}`
	)

	const text = htmlDecode(window.myvars.surveyHeaderTips2)
	const template = `
			<header class="survey-header-msg-lg a-center">
					<h3>${window.myvars.surveyHeaderTips1}</h3>
					<div class="survey-header-order">${window.myvars.orderNumber}: <span>${orderNumber}</span></div>
					<p>${text}</p>
			</header>
			<form id=survey__placeHolder><input type="hidden" name="orderId" value=${orderId}/>${html}</form>
`

	return window.Swal.fire(
		swalOption(
			template,
			true,
			true,
			triggerSurveyUi,
			confirmButtonText,
			'survey__wrapper'
		)
	).then((result) => {
		// if (inPage) window.location.reload(true)
		//
		const data = $('#survey__placeHolder').serialize()
		if (result) {
			// alert('test')
		}

		submitSurvey(data)

		if (window.orderSummary.orderSummarySlideIn === '1' && window.innerWidth > 767) setTimeout(triggerSyzpModalSlide, 3000)

		// if (inPage) clearForm(orderId)
	})
	// }
	//
	// return false
}

export function triggerByPcParameter () {
	const trigerPC = useUrlParameter(window.location.href, 'pc')
	if (trigerPC) trigerPromotionChanel()
}

export default trigerPromotionChanel

